<template>
  <span class="svg-ico-youtube-logo">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5977 4H7.59766C4.59766 4 2.59766 6 2.59766 9V15C2.59766 18 4.59766 20 7.59766 20H17.5977C20.5977 20 22.5977 18 22.5977 15V9C22.5977 6 20.5977 4 17.5977 4ZM14.4877 13.03L12.0176 14.51C11.0176 15.11 10.1976 14.65 10.1976 13.48V10.51C10.1976 9.34001 11.0176 8.88001 12.0176 9.48001L14.4877 10.96C15.4377 11.54 15.4377 12.46 14.4877 13.03Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
